import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'ชุดเช็กลิสต์ก่อนลงสนาม พร้อมใช้',
  description: 'รายการตรวจสอบที่ครบถ้วนก่อนเริ่มคลาสทุกครั้ง เพื่อให้การสอนราบรื่น 100%',
  value: '400฿'
}, {
  number: 2,
  title: 'แผนสำรองวันฝนตกและสนามเล็ก',
  description: 'ขั้นตอนที่ชัดเจนสำหรับวันที่สภาพอากาศหรือสถานที่ไม่เอื้ออำนวย ไม่มีความยุ่งเหยิงอีกต่อไป',
  value: '400฿'
}, {
  number: 3,
  title: 'คู่มือแบ่งกลุ่มเด็กแบบมืออาชีพ',
  description: 'วิธีจัดกลุ่มนักเรียนอย่างมีประสิทธิภาพตามระดับและทักษะ เพื่อผลลัพธ์ที่ดีที่สุด',
  value: '400฿'
}, {
  number: 4,
  title: 'แบบฟอร์มรายงานผู้ปกครอง พร้อมใช้',
  description: 'เทมเพลตพร้อมใช้สำหรับสื่อสารกับผู้ปกครองอย่างชัดเจนและมืออาชีพทุกเดือน',
  value: '400฿'
}, {
  number: 5,
  title: 'คลังเกมวอร์มอัพ 30 แบบ สำหรับทุกระดับ',
  description: 'คลังเกมวอร์มอัพ 30 แบบที่หลากหลาย สนุก และเหมาะสำหรับนักเรียนทุกระดับ',
  value: '400฿'
}, {
  number: 6,
  title: 'แผ่นสรุปโค้ช 1 หน้า ต่อคลาส',
  description: 'แผ่นสรุปรายคลาสแบบ 1 หน้าที่ช่วยให้คุณเตรียมการสอนได้ในเวลาไม่กี่นาที',
  value: '400฿'
}];
export function Bonuses() {
  return <section className="w-full bg-cream-alt py-20 px-4" data-id="element-44">
      <div className="max-w-6xl mx-auto" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-navy-primary mb-4" data-id="element-47">
            6 โบนัสพิเศษที่รวมอยู่ด้วย
          </h2>
          <p className="text-2xl text-gold-accent font-bold" data-id="element-48">
            มูลค่ารวมของโบนัส: 2,400 ฿
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-49">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-lg border-2 border-gold-accent/20 relative overflow-hidden" data-id="element-50">
              <div className="absolute top-4 right-4 bg-gold-accent text-navy-primary px-3 py-1 rounded-full text-sm font-bold" data-id="element-51">
                {bonus.value} ฟรี
              </div>
              <div className="flex items-start gap-4" data-id="element-52">
                <div className="w-12 h-12 bg-gold-accent/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-53">
                  <Gift className="w-6 h-6 text-gold-accent" data-id="element-54" />
                </div>
                <div className="flex-1" data-id="element-55">
                  <h3 className="font-display font-bold text-navy-primary mb-2 pr-20" data-id="element-56">
                    🎁 {bonus.number}. {bonus.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-57">
                    {bonus.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}